export const getSteiermarkData = () => ({
  name: "Steiermark",
  country: "Autriche",
  description: "Steiermark (Styrie) est une région viticole d'Autriche, réputée pour ses vins blancs frais et aromatiques. Cette région bénéficie d'un climat continental avec des influences alpines, créant des conditions idéales pour la production de vins blancs de qualité.",
  type: "region",
  area: "2,500 ha",
  production: "0.15 million hectolitres",
  climate: "Climat continental avec influences alpines, étés frais et hivers froids",
  soil: "Sols calcaires, argileux, granitiques, excellente diversité géologique",
  characteristics: {
    climate: "Climat continental avec influences alpines, étés frais et hivers froids",
    soil: "Sols calcaires, argileux, granitiques, excellente diversité géologique",
    viticulture: "Viticulture traditionnelle, rendements limités, qualité privilégiée"
  },
  wineStyles: {
    white: "Vins blancs frais et aromatiques, avec une acidité vive et des notes minérales",
    red: "Vins rouges légers et fruités, avec des tanins fins",
    rosé: "Rosés délicats et fruités, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture à Steiermark remonte à l'époque romaine. La région a développé une réputation pour ses vins blancs de qualité, notamment le Sauvignon Blanc et le Chardonnay. Aujourd'hui, Steiermark est reconnue pour sa diversité de styles et sa qualité constante.",
  foodPairing: "Cuisine autrichienne traditionnelle, poissons, fromages frais, plats locaux",
  subregions: {
    "Südsteiermark": {
      name: "Südsteiermark",
      description: "Région viticole méridionale, spécialisée dans les vins blancs",
      area: "1,500 ha",
      characteristics: "Sols calcaires, climat continental, vins blancs",
      grapeVarieties: ["sauvignon-blanc", "chardonnay", "welschriesling", "muscat"]
    },
    "Weststeiermark": {
      name: "Weststeiermark",
      description: "Région viticole occidentale produisant des vins rouges et blancs",
      area: "600 ha",
      characteristics: "Sols argileux, climat tempéré, vins équilibrés",
      grapeVarieties: ["blaufrankisch", "zweigelt", "sauvignon-blanc", "chardonnay"]
    },
    "Oststeiermark": {
      name: "Oststeiermark",
      description: "Région viticole orientale avec des vignobles établis",
      area: "400 ha",
      characteristics: "Sols granitiques, microclimats, vins aromatiques",
      grapeVarieties: ["welschriesling", "muscat", "sauvignon-blanc", "chardonnay"]
    }
  },
  grapeVarieties: [
    {
      name: "Sauvignon Blanc",
      percentage: "40%",
      description: "Cépage blanc principal, produisant des vins frais et aromatiques",
      characteristics: "Frais, aromatique, acidité vive",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Chardonnay",
      percentage: "25%",
      description: "Cépage blanc produisant des vins secs et équilibrés",
      characteristics: "Sec, équilibré, notes de fruits blancs",
      wineStyles: "Sec, moyen-corps, complexe"
    },
    {
      name: "Welschriesling",
      percentage: "20%",
      description: "Cépage blanc produisant des vins secs et aromatiques",
      characteristics: "Sec, aromatique, acidité vive",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Blaufränkisch",
      percentage: "10%",
      description: "Cépage rouge principal, produisant des vins légers et fruités",
      characteristics: "Léger, fruité, tanins fins",
      wineStyles: "Sec, léger, fruité"
    },
    {
      name: "Autres",
      percentage: "5%",
      description: "Autres cépages incluant Muscat, Zweigelt et cépages autochtones",
      characteristics: "Diversifiés, expérimentaux",
      wineStyles: "Variés selon le cépage"
    }
  ],
  mapAreas: [
    { region: "Südsteiermark", x: 15.5, y: 47.0, color: "#4B164C", size: 3 },
    { region: "Weststeiermark", x: 15.3, y: 47.1, color: "#6d2c7a", size: 2 },
    { region: "Oststeiermark", x: 15.7, y: 47.2, color: "#8a4a8a", size: 2 }
  ]
}); 